import { EntryBox } from "./Components/EntryBox";
import { Footer } from "./Components/Footer";
import { Header } from "./Components/header";
import { MainArea } from "./Components/MainArea";
import { ToolsProvider } from "./hooks/ToolsProvider";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { CreateAppForm } from "./Apps/create";
import CategoryForm from "./categories/CategoryManager";
import { DashboardLayout } from "./Components/dashboard/DashboardLayout";
import { AppsIndex } from "./Apps/AppsIndex";
import Login from "./login/Login";
import Signup from "./login/Signup";
import { AuthProvider } from "./auth/AuthContext";
import ProtectedRoute from "./auth/ProtectedRoute";
import { AppDetail } from "./Apps/AppDetail";
import "bootstrap/dist/css/bootstrap.min.css";
import NotFound from "./Components/Notfound.jsx";
import ShowAllCategoryApp from "./Components/allCategoryApps.jsx";
import CategoryWithAside from "./Components/CategoryWithAside.jsx"; // sahi path ka dhyan rakhna
export function App() {
  // const { isAuthenticated, user } = useAuth();

  const getUserData = JSON.parse(localStorage.getItem("user"));

  return (
    <AuthProvider>
      <ToolsProvider>
        <Router>
          <Routes>
            {/*Admin routes */}
            {getUserData?.user?.role === "admin" && (
              <>
                <Route
                  path="/create"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <CreateAppForm />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/apps"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <AppsIndex />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/admin/category"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <CategoryForm />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/"
                  element={
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Header />
                      <EntryBox />
                      <MainArea />

                      <Footer />
                    </div>
                  }
                />

                <Route
                  path="/login"
                  element={
                    // <DashboardLayout>
                    <Login />
                    // </DashboardLayout>
                  }
                />

                <Route
                  path="/signup"
                  element={
                    // <DashboardLayout>
                    <Signup />
                    // </DashboardLayout>
                  }
                />

                <Route
                  path="api/apps/:id"
                  element={
                    <>
                      <Header />
                      <AppDetail />
                      <Footer />
                    </>
                  }
                />

                {/* Show all categorys apps */}
                <Route
                  path="/category"
                  element={
                    <>
                      <Header />
                      <EntryBox />
                      <ShowAllCategoryApp />
                      <Footer />
                    </>
                  }
                />
              </>
            )}

            {/*User routes */}
            {getUserData?.user?.role === "user" && (
              <>
                <Route
                  path="/create"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <CreateAppForm />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/admin/category"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <CategoryForm />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/"
                  element={
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Header />
                      <EntryBox />
                      <MainArea />

                      <Footer />
                    </div>
                  }
                />

                <Route
                  path="/login"
                  element={
                    // <DashboardLayout>
                    <Login />
                    // </DashboardLayout>
                  }
                />

                <Route
                  path="/signup"
                  element={
                    // <DashboardLayout>
                    <Signup />
                    // </DashboardLayout>
                  }
                />

                <Route
                  path="api/apps/:id"
                  element={
                    <>
                      <Header />
                      <AppDetail />
                      <Footer />
                    </>
                  }
                />

                {/* 404 Not Found Page */}
                <Route path="*" element={<NotFound />} />

                {/* Show all categorys apps */}
                <Route
                  path="/category"
                  element={
                    <>
                      <Header />
                      <EntryBox />
                      <ShowAllCategoryApp />
                      <Footer />
                    </>
                  }
                />
              </>
            )}

            <Route
              path="/"
              element={
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Header />
                  <EntryBox />
                  <MainArea />

                  <Footer />
                </div>
              }
            />

            <Route
              path="/login"
              element={
                // <DashboardLayout>
                <Login />
                // </DashboardLayout>
              }
            />

            <Route
              path="/signup"
              element={
                // <DashboardLayout>
                <Signup />
                // </DashboardLayout>
              }
            />

            <Route
              path="api/apps/:id"
              element={
                <>
                  <Header />
                  <AppDetail />
                  <Footer />
                </>
              }
            />
            
            {/* Show all categorys apps */}
            <Route
              path="/category"
              element={
                <>
                  <Header />
                  <EntryBox />
                  <ShowAllCategoryApp />
                  <Footer />
                </>
              }
              
            />

                {/* 404 Not Found Page */}
                <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </ToolsProvider>
    </AuthProvider>
  );
}
